var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPasswordProfile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "password",
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.603,
    height: 20,
    viewBox: "0 0 14.603 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_9371",
    "data-name": "Path 9371",
    d: "M172.5,295.8a.586.586,0,0,1-.586-.586v-2.427a.586.586,0,0,1,1.172,0v2.427A.586.586,0,0,1,172.5,295.8Zm0,0",
    transform: "translate(-165.198 -280.785)",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9372",
    "data-name": "Path 9372",
    d: "M.586,6.427H3.359V3.573A3.775,3.775,0,0,1,7.3,0a3.775,3.775,0,0,1,3.942,3.573V6.427h2.773a.586.586,0,0,1,.586.586v7.493A5.5,5.5,0,0,1,9.109,20H5.493A5.5,5.5,0,0,1,0,14.506V7.013a.586.586,0,0,1,.586-.586Zm9.486-2.854a2.608,2.608,0,0,0-2.77-2.4,2.609,2.609,0,0,0-2.77,2.4V6.427h5.541Zm-8.9,10.934a4.327,4.327,0,0,0,4.322,4.322H9.109a4.327,4.327,0,0,0,4.322-4.322V7.6H1.172Zm0,0",
    transform: "translate(0 0)",
    fill: "currentColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordProfile);
export default __webpack_public_path__ + "static/media/passwordProfile.679b0dcfe086ae8e61e297f8a133d233.svg";
export { ForwardRef as ReactComponent };